module.exports = __webpack_public_path__ + "static/media/Health & Safety Policy.a1931319.pdf";